//@flow
import ContextualPage from "./ContextualPage";

export { ContextualPage };